import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ]
})
export class FormFooterComponent {
  @Input() form: FormGroup;
  @Input() formValid: boolean;
  @Input() isSubmitted: boolean;
  @Input() isClone: boolean;
  @Input() isEdit: boolean;
  @Input() isSaveAddNew: boolean;

  // tslint:disable-next-line:no-output-native
  @Output() submit: EventEmitter<any>;
  @Output() saveAddNew: EventEmitter<any>;
  @Output() cancel: EventEmitter<any>;

  constructor() {
    this.submit = new EventEmitter<any>();
    this.saveAddNew = new EventEmitter<any>();
    this.cancel = new EventEmitter<any>();
  }
}
